import { render, staticRenderFns } from "./BaseDetailMoveData.vue?vue&type=template&id=05ca41e3&"
import script from "./BaseDetailMoveData.vue?vue&type=script&lang=js&"
export * from "./BaseDetailMoveData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports